import tw from 'twin.macro';

// Icon circle + ink per tone. Colour always travels with an icon and text, and
// every ink clears 4.5:1 on white.
export const TONE_STYLES = {
  ok: tw`bg-success_100 text-success`,
  warning: tw`bg-[#FFF1DB] text-[#8A4B00]`,
  problem: tw`bg-error_100 text-[#A61D2A]`,
  info: tw`bg-info_light text-[#3F5670]`,
};
